/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { Icon } from "../../components/Icon"
import { CMSLink } from "../../components/CMSLink"

function ContactSection({ column: { title, info, link, email, phoneNumber, whatsApp, icon } }) {
  const whatsAppNr = whatsApp ? whatsApp.replace("https://wa.me/", "+") : ""
  const telephoneNumber = phoneNumber ? `tel:${phoneNumber.phoneNumberLink}` : ""
  const emailAddress = email ? `mailto:${email}` : ""
  return (
    <div>
      <h2
        sx={{
          fontFamily: "heading",
          fontSize: "20px",
          lineHeight: "20px",
          fontWeight: "medium",
          color: "almostBlack",
          mb: ["11px", "11px", "12px"],
        }}
      >
        <Icon
          name={icon}
          color="almostBlack"
          size="20px"
          sx={{ mr: 3, position: "relative", top: "4px" }}
        />
        <span sx={{ display: ["none", "none", "inline"] }}>{title}</span>
      </h2>
      {phoneNumber && (
        <div>
          <div
            sx={{
              fontFamily: "body",
              fontSize: "17px",
              lineHeight: "23px",
              color: "almostBlack",
              fontWeight: "light",
            }}
          >
            {link}
          </div>
          <p>
            <CMSLink
              link={{ externalUrl: telephoneNumber, newtab: true, follow: false }}
              sx={{
                fontFamily: "body",
                fontSize: "17px",
                lineHeight: "23px",
                color: "almostBlack",
                fontWeight: "light",
              }}
            >
              {phoneNumber.phoneNumberPrinted}
            </CMSLink>
          </p>
        </div>
      )}
      {whatsApp && (
        <div>
          <div
            sx={{
              fontFamily: "body",
              fontSize: "17px",
              lineHeight: "23px",
              color: "almostBlack",
              fontWeight: "light",
            }}
          >
            {link}
          </div>
          <p>
            <CMSLink
              sx={{
                fontFamily: "body",
                fontSize: "17px",
                lineHeight: "23px",
                color: "almostBlack",
                fontWeight: "light",
              }}
              link={{ externalUrl: whatsApp, newtab: true, follow: false }}
            >
              {whatsAppNr}
            </CMSLink>
          </p>
        </div>
      )}
      {email && (
        <div>
          <CMSLink
            link={{ externalUrl: emailAddress, newtab: true, follow: false }}
            sx={{
              fontFamily: "body",
              fontSize: "17px",
              lineHeight: "23px",
              color: "almostBlack",
              fontWeight: "light",
            }}
          >
            {email}
          </CMSLink>
          <p>
            <div
              sx={{
                fontFamily: "body",
                fontSize: "17px",
                lineHeight: "23px",
                color: "almostBlack",
                fontWeight: "light",
              }}
            >
              {info}
            </div>
          </p>
        </div>
      )}
      {info && !email && !phoneNumber && !whatsApp && (
        <p
          sx={{
            fontFamily: "body",
            fontSize: "17px",
            lineHeight: "23px",
            color: "almostBlack",
            fontWeight: "light",
          }}
        >
          {info}
        </p>
      )}
    </div>
  )
}

export { ContactSection }
